import { request } from '../utils/request';

export const getSeeds = params => request.get('/database-seeds/', { params });
export const createSeed = options => request.post('/database-seeds/create', options);
export const updateSeed = options => request.post('/database-seeds/update', options);
export const getDownloadLink = params => request.get('/database-seeds/get-download-link', { params })
